import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizePresentations = data => {
  const presentation = new schema.Entity('presentations')
  return normalize(data, [presentation])
}

const MyPresentations = combineReducers({
  fetching: createRequestReducer('MY_PRESENTATIONS:FETCH', {
    pending: true,
    params: { initiator: 'FIRST_LOAD' }
  }),
  creating: createRequestReducer('MY_PRESENTATIONS:CREATE'),
  copying: createMappedRequestReducer('MY_PRESENTATIONS:COPY'),
  settingToPublic: createMappedRequestReducer('MY_PRESENTATIONS:SET_TO_PUBLIC'),
  deleting: createMappedRequestReducer('MY_PRESENTATIONS:DELETE'),
  settingToPrivate: createMappedRequestReducer(
    'MY_PRESENTATIONS:SET_TO_PRIVATE'
  ),
  pagination: createReducer(null, {
    'MY_PRESENTATIONS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.presentations_pagination
  }),
  filters: createReducer(
    { search_string: '', filter: null },
    {
      'MY_PRESENTATIONS:FETCH_REQUEST': (state, { params }) => params
    }
  ),
  data: createReducer(null, {
    'MY_PRESENTATIONS:FETCH_REQUEST': (state, { params }) =>
      params.initiator === 'FIRST_LOAD' ? null : state,
    'MY_PRESENTATIONS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizePresentations(response.data.presentations),
    'MY_PRESENTATIONS:SET_TO_PUBLIC_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      entities: {
        presentations: {
          ...state.entities.presentations,
          [params.id]: {
            ...state.entities.presentations[params.id],
            public: true
          }
        }
      }
    }),
    'MY_PRESENTATIONS:SET_TO_PRIVATE_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      entities: {
        presentations: {
          ...state.entities.presentations,
          [params.id]: {
            ...state.entities.presentations[params.id],
            public: false
          }
        }
      }
    })
  })
})

export default MyPresentations
